import {gql} from '@apollo/client';
import {LibraryAlbumComplete} from './LibraryAlbumCompleteFragment';
import {LibrarySongComplete} from './LibrarySongCompleteFragment';

export const LibraryAlbumWithSongs = {
  libraryAlbum: gql`
    fragment LibraryAlbumWithSongsFragment on LibraryAlbum {
      ...LibraryAlbumComplete
      tracks {
        ...LibrarySongComplete
      }
    }
    ${LibraryAlbumComplete.libraryAlbum}
    ${LibrarySongComplete.librarySong}
  `,
};
